import { Suggestion } from '@wizbii/models';

export class AddToShoppingCart {
  static readonly type = '[ShoppingCart] Add article';
  constructor(public article: Suggestion) {}
}

export class RemoveFromShoppingCart {
  static readonly type = '[ShoppingCart] Remove article';
  constructor(public article: Suggestion) {}
}

export class ClearShoppingCart {
  static readonly type = '[ShoppingCart] Clear';
}

export class GetShoppingCart {
  static readonly type = '[ShoppingCart] Get';
}
